import React,{Fragment, useEffect} from 'react';
import {useParams} from 'react-router-dom'
import InfinitProgressBar from '../../components/InfiniteProgressBar';
import PageHeader from '../../components/PageHeader';
import PageWrapper from "../../components/PageWrapper";
import {useAboutUs} from "./../../queries/aboutUs";
import AboutUsDetail from "./AboutUsDetail";


const AboutUsDetails = (props) => {
    
    const aboutInfo = useAboutUs(props.aboutId);
    
    
    if (aboutInfo.error) return <div>error!</div>
    if (aboutInfo.loading) return <InfinitProgressBar/>
    
    return ( aboutInfo.data ?
        <Fragment>
            <PageHeader
                    bgImg={aboutInfo.data.aboutUsPageHeader[0].aboutUsPageHeaderImage.urls[0]}
                    title={"درباره ما"}
                    content={aboutInfo.data.aboutUs[0].displayText}
                    
                />
            <PageWrapper classes={'product-details-wrapper sm-top'}>
                <div className="col-12">
                    <AboutUsDetail res={aboutInfo.data}/>
                    {/* <SkillsExperience teamMember={teamMember}/> */}
                    {/* <Education teamMember={teamMember}/> */}
                </div>
            </PageWrapper>
        </Fragment>
    : null);
};

export default AboutUsDetails;